


import React, { useEffect, useState } from 'react';

import { IntegrationConfiguration } from './configuration/IntegrationConfiguration';
import { AppConfiguration } from './configuration/AppConfiguration';
import { InfonovaUiWebComponentsConfiguration } from './configuration/InfonovaUiWebComponentsConfiguration';


import "../infonova/infonova";
import { TopBar } from './components/bar/TopBar';


IntegrationConfiguration.configure(AppConfiguration.configure, InfonovaUiWebComponentsConfiguration.configure);


export const AppGuard = () => {
    const [ready, setReady] = useState(false);
    const [integrationReady, setIntegrationReady] = useState(false);

    const handleLoading = () => {
        const integrationListener = (event) => {
            setIntegrationReady(true);

            window.removeEventListener('integration-ready', integrationListener);
        };

        if (window.$infonova) {
            if (!ready) {
                setReady(true);
            }
        }

        window.addEventListener("infonova-app-started", integrationListener);
    }

    useEffect(() => {
        handleLoading();
    });



    return (
        <div style={{ width: "fit-content", height: "fit-content" }}>
            <div className="appguard" style={{ width: "fit-content", height: "fit-content" }}>
                {/* <View
                style={[
                    styles.container,
                    {
                        flexDirection: 'row',
                    },
                ]}> */}

            </div>
            {/* </View> */}
            {
                integrationReady && <TopBar></TopBar>
            }
        </div>
    );
    // }
}
